import React from 'react';
import VBDropdown from '@vb-js-commons/new/vbDropdown';
import VBLoadingScreen from "@vb-js-commons/vbLoadingScreen";
import Modal from 'react-bootstrap/Modal';
import Cookies from 'js-cookie';
import { validateEmail, userExists, registerUser, loginUser, getUserRights } from './api/index';


import styled from 'styled-components'
import { LoginContext } from '../login/context/LoginContext';

const Labels = styled.p`
text-align: left;
font-size:  18px;
color: #2a2e33 !important;
opacity: 1;
margin:0.5rem 0rem;
@media (min-width: 992px) {
 line-height: 30px;
 font-size: 22px;
 color: #2a2e33 !important; 
}
`

class ComparisonFilter extends React.Component {
  static contextType = LoginContext;
  constructor(props) {
    super();

    let defaultState = {
      bliPluskundModal: false,
      successModal: false,
      errorModal: false,
      has_searched: false,
      loading: false,
      errors: {},
      isReg: null,
      isLogged: this.context?.isLogged ?? false,
      didRegModalShow: false,
      isPremium: props.hasPremium,
      formData: {
        tree: { value: null, label: null },
        muni: { value: null, label: null },
      },
      messageSentModal: false,
    };

    let val = Cookies.get("price_comp_filter");

    if (val) {
      let vals = val.split(",");
      let municipalitiesVals = Window.react_data.lists.munis.map(itm =>
        itm.value.toString()
      );
      if (!municipalitiesVals.includes(vals[1].toString())) {
        Cookies.remove("price_comp_filter");
        location.reload();
        return;
      }

      let treeVals = Window.react_data.lists.trees.map(itm =>
        itm.value.toString()
      );
      if (!treeVals.includes(vals[0].toString())) {
        Cookies.remove("price_comp_filter");
        location.reload();
        return;
      }

      defaultState.formData = {
        tree: { value: vals[0], label: vals[2] },
        muni: { value: vals[1], label: vals[3] },
      };

    }

    this.state = defaultState;
  }

  checkEmail(val) {
    // Check if email is a valid email before checking if the user exists
    if (validateEmail(val)) {
      // clear timeout if the user is still typing before timers is over
      if (this.timeout) { clearTimeout(this.timeout) };

      this.timeout = setTimeout(() => {
        userExists(val).then(resp => {
          if(resp.ok){
            resp.json().then((json) => {
              this.setState({ isReg: json.exists });
            })
          } else {
            this.setState({ loading: false, errorModal: true });
          }
        })
      }, 100)
    }
  }

  loadGraphs() {
    this.props.onFilter(this.state.formData.tree.value, this.state.formData.muni.value, this.state.formData.tree.label, this.state.formData.muni.label);
    this.setState({ "has_searched": true, loading:false });
  }


  handleSubmit(){
    const LoginContext = this.context
    let checklist = []
    let data = this.state.formData;
    let action = null;
    if (this.state.isLogged){
      action = 'continue';
      checklist.push('muni','tree')
    }
    else {
      action = 'login'
      checklist.push('muni','tree')
    }

    let validation = {};
    checklist.forEach(check=>{
      if (check === 'tree' && (!data.tree || !data.tree.value)) {
        validation.tree = "Du måste välja ett trädslag";
      }
      if (check == 'muni' && (!data.muni || !data.muni.value)) {
        validation.muni = "Du måste välja en kommun";
      }
    })

    if (Object.keys(validation).length !== 0){
      this.setState({errors: validation})
    }
    else {
      if (action == 'continue') {
        this.setState({ loading: true })
        Cookies.set("price_comp_filter", data.tree.value + "," + data.muni.value + "," + data.tree.label + "," + data.muni.label);
        this.loadGraphs();
        this.setState({ errors: validation, loading: false, })
      }
      else if (action == 'login'){
        LoginContext.setShow(true)
      }
    }
    
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isLogged !== this.context.isLogged) {
      this.setState({ isLogged: this.context.isLogged });

      if (this.context.isLogged && this.state.formData.tree?.value !== null && this.state.formData.muni?.value !== null) {
        setTimeout(() => this.handleSubmit(), 100);
      }
    }
  }


  contactUs() {
    const LoginContext = this.context
    if (this.state.isLogged) {
      const headers = {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      }
      let data = {
        "message": "Användaren begärde att bli kontaktad angående virkespriser.",
      }
      fetch("/create-hubspot-ticket/", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({"data":data})
      }).then(res => {
        if (res.ok){
          this.setState({ messageSentModal: true, })
        }
        else{
          console.error(json)
        }    
      });
    }
    else {
     LoginContext.setShow(true)
    }
  }


  render() {
    const treeOptions = Window.react_data.lists.trees.slice(4).concat(Window.react_data.lists.trees.slice(0, 4))
    return <div className="mt-0  mt-lg-2">
      <VBLoadingScreen show_loading={this.state.loading} />
      <div className='row justify-content-between'>
        <div className="col-12 mb-3">
          <VBDropdown
            default="true"
            initial={this.state.formData.muni.value}
            label={<p className='n-fs-5 white d-block'>Välj kommun</p>}
            placeholder="Ange kommun"
            error={this.state.errors.muni}
            options={Window.react_data.lists.munis}
            onFocus={() => this.setState({ errors: { ...this.state.errors, muni: '' } })}
            onChange={(selected) => { this.setState({ formData: { ...this.state.formData, muni: selected } }); }} />
        </div>
        <div className="col-12">
          <VBDropdown
            default="true"
            initial={this.state.formData.tree.value}
            placeholder="Välj trädslag"
            label={<p className='n-fs-5 white d-block'>Välj trädslag</p>}
            error={this.state.errors.tree}
            ref={this.tree_dll}
            options={treeOptions}
            onFocus={() => this.setState({ errors: { ...this.state.errors, tree: '' } })}
            onChange={(selected) => { this.setState({ formData: { ...this.state.formData, tree: selected } }); }} />
        </div>
      </div>


      <div className="d-flex flex-column flex-md-row justify-content-md-start mt-4 mt-md-3">

        <button className="n-btn btn-core mb-3 mb-md-0 me-md-3" onClick={() => { this.handleSubmit(); }}>Visa resultat</button>
        <button className="n-btn btn-outline btn-core primary-core" onClick={() => {this.contactUs()}}>Kontakta rådgivare</button>
      </div>
      <Modal show={this.state.bliPluskundModal} onHide={() => this.setState({ bliPluskundModal: false })} size="md" contentClassName="bg-primary-dark p-2" centered>
        <Modal.Header className="align-items-start border-0" closeVariant="black" closeButton>
          <h2 className="primary-main mb-0">Vill du ta del av all information?</h2>
          <h2 className="primary-main mb-0">Bli Pluskund</h2>
        </Modal.Header>
        <Modal.Body className="py-0">
          <p className="white">När du blir Pluskund kan du ta del av all information på Treebula. Exempelvis så ser du bolagsnamn, massavedspriser, antalet köpare i din kommun och mycket mer.</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center justify-content-lg-between border-0">
          <a href={Window.react_data.links.premium} className="btn btn-tertiary text-nowrap">Läs mer om Pluskund</a>
        </Modal.Footer>
      </Modal>
        <Modal show={this.state.errorModal} onHide={() => this.setState({ errorModal: false })} contentClassName="bg-red-alert p-2" centered>
            <Modal.Body>
                <h2 className="primary-main">OOPS! NÅGOT GICK FEL.</h2>
                <p className='white py-3'>Ring <a href="tel:08339944" className="fw-bold primary-main">08-33 99 44</a> så hjälpa vi dig vidare.</p>
                <button type="button" className="btn btn-secondary btn-sm float-end" onClick={() => this.setState({ errorModal: false })}>FORTSÄTT</button>
            </Modal.Body>
        </Modal>

        <Modal show={this.state.successModal} onHide={() => this.setState({ successModal: false, didRegModalShow: true })} size="lg" contentClassName="bg-neutral-cloud neutral-charcoal p-2" centered>
          <Modal.Header className="align-items-start border-0" closeButton>
              <h4 className="mb-0">Välkommen till Treebula</h4>
          </Modal.Header>
          <Modal.Body className="py-0">
              <p className="n-fs-6">Ditt konto är nu registrerat hos oss och du kan komma igång med att använda alla våra digitala tjänster kostnadsfritt. Jämför virkespriser, ta in anbud på avverkning och gallring, få rådgivning eller skapa en skogsbruksplan - digitalt och helt utan förbindelser.</p>

              <p className="n-fs-6">Ditt lösenord har skickats till den mailadress du angav vid registrering, använd den för att logga in på dina sidor.</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-end border-0">
              <button type="button" className="n-btn btn-forest-green" onClick={() => this.setState({ successModal: false, didRegModalShow: true })}>Stäng</button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.messageSentModal} onHide={() => { this.setState({ messageSentModal: false }) }}size="md" contentClassName="bg-white" centered>
          <Modal.Header className="align-items-start border-0" closeVariant="white" closeButton>
            <h2 className="supp-charcoal mb-0">Skickat</h2>
          </Modal.Header>
          <Modal.Body className="py-0">
            <p className="supp-charcoal mb-0">Ditt meddelande har skickats och vi kontaktar dig inom kort.</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-end border-0">
            <button className="n-btn btn-forest-green btn-sm" onClick={() => this.setState({ messageSentModal: false })}>Stäng</button>
          </Modal.Footer>
        </Modal>
    </div>
  }
}

export default ComparisonFilter;